import { useMemo, useState } from 'react'
import { copyConfig, integrationsConfig } from '../../config'

const HERO_GENERATION_DELAY = 1200

export function Hero() {
  const [isGenerating, setIsGenerating] = useState(false)
  const [hasGenerated, setHasGenerated] = useState(false)

  const primarySources = useMemo(() => integrationsConfig.primary.map((provider) => provider.label).join(' • '), [])

  const handleGenerate = () => {
    if (isGenerating) return
    setIsGenerating(true)
    setHasGenerated(false)

    window.setTimeout(() => {
      setIsGenerating(false)
      setHasGenerated(true)
    }, HERO_GENERATION_DELAY)
  }

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 opacity-40" aria-hidden>
        <div className="absolute -top-24 -left-20 w-[520px] h-[520px] rounded-full blur-3xl bg-glow" />
        <div className="absolute -bottom-32 -right-24 w-[560px] h-[560px] rounded-full blur-3xl bg-accent" />
      </div>
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-3xl space-y-6">
          <h1 className="text-3xl md:text-5xl font-semibold leading-tight text-ink">
            {copyConfig.hero_h1_part1}
            <span className="text-transparent bg-clip-text bg-logo-gradient">
              {copyConfig.hero_h1_highlight}
            </span>
            {copyConfig.hero_h1_part2}
          </h1>
          <p className="text-muted max-w-2xl text-base md:text-lg">{copyConfig.hero_sub}</p>
          <p className="text-sm text-muted/90">
            Connected data sources: <span className="text-ink">{primarySources}</span>
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <button
              type="button"
              onClick={handleGenerate}
              className="px-5 py-3 rounded-2xl bg-cta-gradient text-white font-semibold shadow-lg shadow-glow/20 transition hover:opacity-90 disabled:opacity-60 disabled:cursor-not-allowed"
              disabled={isGenerating}
            >
              {isGenerating ? 'Generating…' : copyConfig.cta_primary}
            </button>
            <a href="/open" className="px-5 py-3 rounded-2xl border border-border-light text-ink text-center hover:bg-surface-light">
              {copyConfig.cta_secondary}
            </a>
            <a href="#pricing" className="px-5 py-3 rounded-2xl border border-border-light text-ink text-center hover:bg-surface-light">
              {copyConfig.cta_tertiary}
            </a>
          </div>
          <div className="text-sm text-brand-glow min-h-[1.5rem]">
            {isGenerating && 'Running valuation simulation with sample data…'}
            {!isGenerating && hasGenerated && 'Sample valuation ready. Check the Signals section for investor fit assumptions.'}
          </div>
        </div>
      </div>
    </section>
  )
}
